/**
 * Title Case: capitalize the first letter of each word.
 * Lowercases the rest so ALL-CAPS stored titles display as Title Case.
 */
export function toTitleCase(value) {
    if (value == null || value === '') return '';
    return String(value)
        .toLowerCase()
        .replace(/\b([a-z0-9])/g, (char) => char.toUpperCase());
}
